import React from 'react';
import { omit } from '../../utils/index.js';
import { LoadingSpinnerElement } from './loading-spinner.styles.js';
export const LoadingSpinner = (props) => (React.createElement(LoadingSpinnerElement, { ...omit(props, 'ref') }));
//# sourceMappingURL=loading-spinner.component.js.map